import type { ReactNode } from 'react'

import { PageHeaderActionPrimary } from '@/components/navigation/page-header-actions'

export type DashboardSectionActionProps = {
  onClick: () => void
  children: ReactNode
}

/** Section header / empty-state actions — delegates to `PageHeaderActionPrimary`. */
export function DashboardSectionAction({ onClick, children }: DashboardSectionActionProps) {
  return (
    <PageHeaderActionPrimary type="button" onClick={onClick}>
      {children}
    </PageHeaderActionPrimary>
  )
}
